<template>
  <div class="mail-list-info">
    <div class="title">
      邮寄资料清单
      <el-button type="primary" @click="delivery()" v-if="canSendExpress(order) && !order.enable_api">寄送资料</el-button>
    </div>

    <div class="express-tips">上上签不接受快递到付，否则将被退回，敬请知悉。</div>

    <div class="express-wrap clearfix" v-if="showSimpleExpress(order)">
      <div class="row">
        <div class="row-left">
          <div class="row-title">邮寄地址</div>
        </div>
        <div class="row-right" v-if="order.supplier_address">
          <div class="express-name">
            <span>{{order.supplier_address.addressee}}（{{ order.country + '，' + User.peer.visa_peer_id }}）</span>
            <span class="num" v-text="order.supplier_address.mobile_phone"></span>
          </div>
          <div class="express-detail" v-text="getAddress(pcds, order.supplier_address)"></div>
          <!-- <div class="express-tips">* 上上签不接受快递到付，否则将被退回，敬请知悉。</div> -->
        </div>
      </div>
    </div>

    <sf-express-info v-else :order="order" />

    <order-applicant-mail-list :order="order" />

    <!-- 寄送资料 -->
    <express-type-choose :orderId="order.user_order_id" :expressChooseModal="expressTypeSelectModal" @modalClose="addressModalClose" />
  </div>
</template>

<script>
import User from '@/libs/user';
import adddressUtils from '../../libs/address-utils';
import pcdService from '../../services/pcd-service';
import orderApplicantMailList from './order-applicant-mail-list';
import sfExpressInfo from './sf-express-info';
import expressTypeChoose from '../express-type-choose';
import orderService from '../../services/order-service';

export default {
  name: 'orderMailList',
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      pcds: {},
      expressTypeSelectModal: false,
      User,
    };
  },
  created() {
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
  components: {
    orderApplicantMailList,
    sfExpressInfo,
    expressTypeChoose,
  },
  methods: {

    delivery() {
      orderService.pickUpCheck(this.order.user_order_id).then(() => {
        this.expressTypeSelectModal = true;
      });
    },

    getAddress: adddressUtils.getAddress,

    /**
     * 寄送资料
     * @param {Object} order 订单数据
     * @return {Boolean} 是否可以寄送资料
     */
    canSendExpress(order) {
      if (!order) return false;

      // 待邮寄资料;
      const waittingForSendMaterial = order.order_status === 4;

      // 下单前未选择顺丰上门取件
      const notSelectedSFExpress = !order.order_pickup;

      // 顺丰上门取件状态为已取消
      const SFExpressCanceled = order.order_pickup && order.order_pickup[0].status === 0; // 已取消

      // 下了顺丰订单但是没有支付
      const SFExpressOrderNotPay = order.order_pickup && !order.order_pickup[0].tracking_number;

      return waittingForSendMaterial && (notSelectedSFExpress || SFExpressCanceled || SFExpressOrderNotPay);
    },

    /**
     * 关闭地址对话框
     * @param {Number} 订单编号
     * @return {Null}
     */
    addressModalClose(orderId) {
      this.expressTypeSelectModal = false;
      if (orderId) {
        this.order.order_status = 5;
      }
    },

    /**
     * 是否该显示原始的快递信息
     * @param {Object} order 订单信息
     * @return {Boolean} 是否显示
     */
    showSimpleExpress(order) {
      if (!order) return true;

      const signed = this.isExpressSigned(order);

      if (signed) {
        return true;
      }

      if (order.order_pickup) {
        return order.order_pickup[0].status === 0 || !order.order_pickup[0].tracking_number;
      }
      return true;
    },

    /**
     * 资料是否已收件
     * @param {Object} order 订单信息
     * @return {Boolean} 是否展示
     */
    isExpressSigned(order) {
      if (!order) return true;

      // 已经寄了或者已取件(这要有一个收件成功了,代表至少第一次寄件成功了,也就是签收了)
      if (order.supplier_express && order.supplier_express.length > 0) {
        return order.supplier_express.some(express =>
          express.express_status === 1, // 已签收
        );
      }

      // 还没寄或者顺丰待取件
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.mail-list-info {
  background-color: #fff;
  .express-tips {
    height: 40px;
    background-color: #ffffde;
    font-size: 14px;
    color: #ff5a60;
    line-height: 40px;
    padding: 0 20px 0 45px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 12px;
      left: 20px;
      height: 16px;
      width: 16px;
      background-image: url(../../assets/imgs/order-detail/icon.png);
      background-repeat: no-repeat;
      background-size: 16px 16px;
    }
  }
  .title {
    position: relative;
    padding: 18px 20px 2px 20px;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    height: 50px;
    border-bottom: 1px solid #f0f0f0;
    .el-button {
      position: absolute;
      right: 15px;
      top: 7px;
    }
  }
  .express-wrap {
    background-color: white;
    font-size: 14px;

    .row {
      padding: 20px 40px;
      display: table;
      width: 100%;
      position: relative;

      &::after {
        display: block;
        content: "";
        position: absolute;
        bottom: 0;
        left: 40px;
        right: 20px;
        width: 840px;
        border-bottom: 1px solid #f0f0f0;
      }
    }

    .row-left,
    .row-right {
      display: table-cell;
      vertical-align: middle;
    }

    .row-left {
      width: 107px;
    }

    .row-title {
      font-size: 16px;
      color: #333;
    }

    .express-name {
      color: #333;

      .num {
        color: #777;
        margin-left: 20px;
      }
    }

    .express-detail {
      color: #777;
      line-height: 1.5;
      margin-top: 10px;
    }
    .express-tips {
      margin-top: 10px;
      color: #ff5a60;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/order-detail/order-mail-list.vue